// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_BF4","cls2":"RelatedPapers-cls2_uAN RelatedPapers-cls1_BF4"};